<template>
  <div class="block-stats">
    <bimContainer>
      <bimCol cols=12 md=10 class="mx-auto">
        <div class="stats d-flex flex-wrap">
          <div
            v-for="stat of stats"
            :key="stat.text"
            class="stats__item"
          >
            <bim-text adaptive type="main" bold class="stats__item-count text-center">{{ stat.count }}</bim-text>
            <bim-text adaptive type="main" bold class="stats__item-text text-center">{{ stat.text }}</bim-text>
          </div>
        </div>
      </bimCol>
    </bimContainer>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer"
import bimCol from "@bimlib/components/bimCol"
const img_catalog = "/dist/assets/front_white/img/landing_estimate/"
export default {
  name: "",
  components: {
    bimContainer,
    bimCol,
  },
  data() {
    return {
      stats: [
        {
          count: "338",
          text: "производителей",
        },
        {
          count: "27 343 431",
          text: "предложений строительной продукции и материалов",
        },
        {
          count: "456",
          text: "поставщиков",
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.block-stats {
  padding: 57px 0;
  background-color: $primary-color-75;
}

.text-center {
  text-align: center; 
}

.stats {
  .stats__item {
    flex: 1;

    @media screen and (min-width: $breakpoint-lg) {
      &:not(:last-child) {
        margin-right: 33px;
      }
    }

    @media screen and (max-width: $breakpoint-lg) {
      flex: 0 0 100%;
      &:not(:last-child) {
        margin-bottom: 32px;
      }
    }

    .stats__item-count {
      color: $primary-color;
      white-space: nowrap;
      font-size: 68px;

      @media screen and (max-width: $breakpoint-sm) {
        font-size: 42px;
      }
    }
  }
}
</style>
